<div data-test="slack-not-linked" class="slack-not-linked-container">
  <section *ngIf="isOwnerAdmin">
    <h3 data-test="slack-admin-header">Share reports with your team on Slack</h3>
    <p data-test="slack-admin-instructions" class="slack-not-linked-instructions">
      Add Mode to your Slack workspace from the Slack Application page in Settings.
    </p>
    <div class="slack-settings-link">
      <a data-test="slack-admin-settings-link" target="_self" [href]="slackAppSettingsUrl"> Go to Slack Application Settings </a>
      <capra-icon icon="icon-new-tab"></capra-icon>
    </div>
  </section>

  <section *ngIf="!isOwnerAdmin">
    <h3 data-test="slack-non-admin-header">Mode needs to be added to your Slack workspace</h3>
    <p data-test="slack-non-admin-instructions">Ask your Admin to add Mode to your Slack workspace by sending them this link:</p>
    <capra-button class="slack-non-admin-button"
      data-test="slack-non-admin-button"
      text="Copy Link"
      variant="secondary"
      color="neutral"
      icon="icon-link"
      modeClipboard
      [clipboardText]="copyLink"
    ></capra-button>
  </section>
</div>
